import React from "react";
import { Environment, Lightformer } from "@react-three/drei";

export default function SceneEnvironment() {
  return (
    <>
      <Environment
        files="./envMaps/studio_country_hall_1ks.hdr"
        background={true}
        environmentIntensity={0.9}
        environmentRotation={[0, -Math.PI / 5, 0]}
      >
        {/* <Lightformer
          form="rect"
          intensity={5}
          color="white"
          scale={[65, 80]}
          target={[0, 0, 0]}
          position={[-40, 0, 150]}
        />
        <Lightformer
          form="rect"
          intensity={20}
          color="white"
          scale={[10, 50]}
          target={[0, 0, 0]}
          position={[-40, 0, 140]}
        />
        <Lightformer
          form="rect"
          intensity={5}
          color="white"
          scale={[50, 50]}
          target={[0, 0, 0]}
          position={[80, 0, 150]}
        /> */}
      </Environment>
    </>
  );
}
